import { httpsCallable } from 'firebase/functions'
import { functions } from './firebase'

export interface UserTrackingData {
  // Browser info
  userAgent: string
  language: string
  platform: string
  screenWidth: number
  screenHeight: number
  colorDepth: number
  timezone: string
  cookiesEnabled: boolean
}

/**
 * Collect browser and device information
 */
export function collectBrowserInfo(): UserTrackingData {
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    colorDepth: window.screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    cookiesEnabled: navigator.cookieEnabled,
  }
}

/**
 * Track user session - call this on anonymous login
 * Only collects browser info, IP address is captured server-side
 */
export async function trackUserSession(): Promise<void> {
  try {
    const browserInfo = collectBrowserInfo()

    // Send to Cloud Function (IP address captured server-side)
    const trackSessionFn = httpsCallable(functions, 'trackUserSession')
    await trackSessionFn(browserInfo)
  } catch (error) {
    console.error('Failed to track user session:', error)
    // Don't throw - tracking failure shouldn't break the app
  }
}
